import { Component, OnInit, Input } from '@angular/core';
import { URL_SERVICIOS  } from '../../../core/config/config';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})

export class SliderComponent implements OnInit {

  @Input() strSYS38COD    : string = '';
  @Input() arrSLIDES      : any;

  slider : any = [];

  constructor() { }

  ngOnInit(): void {

    this.arrSLIDES.forEach(item=>{
      this.slider.push(URL_SERVICIOS+ '/uploads/' + item.RUTA);
    })
  }

}
